import React from 'react';
import { FormattedMessage } from 'react-intl';
import './Footer.scss';

const Footer = () => {
  return (
    <footer>
      <div className="Footer">
        <div className="container">
          <div className="disclaimer_container">
            <div className="footer-disclaimer">
              <p className="footer-disclaimer__lead">
                <FormattedMessage id="footer.disclaimerLead" />
              </p>
              <p className="footer-disclaimer__text">
                <FormattedMessage id="footer.disclaimerText" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
